// removed by extract-text-webpack-plugin
module.exports = {"m-fieldset":"_2OeDz6LffcuhP-dBE-MlZ4","privacyPolicyField":"_3GQMmXqsLJ9MYORYg-YuZR","paymentFieldSet":"_2CO2W2xP2G6_1BJB2GxsB7"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/FormInput/FieldsetStyle.scss
// module id = 950
// module chunks = 0